<template>
  <div class="date-picker" :class="{ block }">
    <v-date-picker
      class="range"
      locale="mn"
      v-model="date"
      v-if="!range"
      :max-date="maxDate"
      :min-date="minDate"
      :is-dark="dark"
    >
      <template #default="{ togglePopover }">
        <div class="flex flex-wrap">
          <button
            class=""
            type="button"
            ref="button"
            @click.stop="dateSelected($event, date, togglePopover)"
          >
            <i class="sr sr-calendar"></i>
            {{ getDate(date) }}
          </button>
        </div>
      </template>
    </v-date-picker>
    <v-date-picker
      locale="mn"
      class="range"
      v-model="dates"
      v-else-if="range"
      :is-range="range"
      :max-date="maxDate"
      :min-date="minDate"
      :is-dark="dark"
    >
      <template #default="{ togglePopover }">
        <div class="flex flex-wrap">
          <button
            class=""
            ref="button"
            @click.stop="dateSelected($event, date, togglePopover)"
          >
            <i class="sr sr-calendar"></i>
            {{ getDate(dates.start) }} - {{ getDate(dates.end) }}
          </button>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  props: {
    range: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    dateProp: {
      type: Date,
      default: () => new Date(),
    },
    datesProp: {
      type: Object,
      default: () => ({
        start: new Date(),
        end: new Date(),
      }),
    },
    maxDate: {
      type: Date,
      default: null,
    },
    minDate: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      date: null,
      dates: null,
      lock: false,
    }
  },
  computed: {
    ...mapState('common', ['dark']),
  },
  watch: {
    datesProp(newVal, oldVal) {
      if (newVal && newVal.start && newVal.end) {
        this.dates = newVal
        this.lock = true
      }
    },
    dates() {
      if (this.range && !this.lock) {
        this.$emit('change', this.dates)
      } else {
        this.$emit('change', this.date)
      }
      this.lock = false
    },
    date() {
      if (!this.lock) {
        this.$emit('change', this.date)
      }
      this.lock = false
    },
  },
  created() {
    if (this.datesProp && this.datesProp.start && this.datesProp.end) {
      this.dates = this.datesProp
      this.lock = true
    }
    if (this.dateProp) {
      this.date = this.dateProp
      this.lock = true
    }
  },
  methods: {
    dateSelected(e, date, toggle) {
      toggle({ ref: e.target })
    },
    getDate(date) {
      return moment(date).format('YYYY-MM-DD').toString()
    },
  },
}
</script>

<style lang="scss">
@import './DatePicker.scss';
</style>
